import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  border-top: 1px solid rgba(242, 242, 242, 0.3);
  & > * {
    margin-bottom: 20px;
  }
  & h2 {
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-bottom: 10px;
  }
`;
